import React from 'react';
import { Skeleton } from 'primereact/skeleton';
import { Divider } from 'components/_new/Divider';
import { Box, BoxSection } from 'components/_new/Box';

export const RecommendedArticlesSkeleton = () => {
	return (
		<>
			<div className="flex flex-column gap-1">
				<Skeleton width="15rem" height="2rem" className="mb-2" />

				<div className="flex flex-column gap-4">
					<div className="flex flex-row gap-2  p-1">
						{[1, 2, 3, 4].map((i) => (
							<Skeleton
								key={i}
								width="10rem"
								height="2.5rem"
								borderRadius="2rem"
								className="flex-shrink-0"
							/>
						))}
					</div>

					<div className="flex flex-row gap-2 justify-content-start align-content-stretch ">
						{[1, 2, 3].map((i) => (
							<div key={i} className="flex article-tile" style={{ flexShrink: 0 }}>
								<Box variant="white-bordered" className="w-full" style={{ width: '280px' }}>
									<BoxSection>
										<Skeleton width="100%" height="8rem" borderRadius="0.5rem" />
									</BoxSection>
									<BoxSection horizontal contentClassName="justify-content-between">
										<div className="inline-flex gap-2 align-items-center">
											<Skeleton shape="circle" size="1.5rem" />
											<Skeleton shape="circle" size="1.5rem" />
											<Skeleton shape="circle" size="1.5rem" />
										</div>
										<Skeleton width="3rem" height="1.5rem" />
									</BoxSection>
									<BoxSection>
										<Skeleton width="100%" height="1rem" className="mb-2" />
										<Skeleton width="80%" height="1rem" />
									</BoxSection>
									<BoxSection>
										<Skeleton width="100%" height="2.5rem" borderRadius="0.375rem" />
									</BoxSection>
								</Box>
							</div>
						))}
					</div>
				</div>
			</div>
			<Divider />
		</>
	);
};
